module.exports = __webpack_public_path__ + "static/parade-2019-house10-2548d844eff79f32d27c789885820ea9.jpg";